import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, retry } from 'rxjs/operators';
import { UserData } from './auth.models';
import * as countries_data from '../../../assets/countries.json';
import { IndexedDBService } from './indexedDB.service';
import { FormatPhoneNumber } from '../../shared/pipes/auth.pipe';
import { UrlLambdaApi, UrlPhpApi } from './models';
import { environment } from '@env/environment';
import { TokenService } from './token.service';



@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private tokenService = inject(TokenService);

  public userLogged: any;
  public countries: any;
  public countries_copy: any;
  public country: any;
  public userData: UserData;
  public userCountry: any = {
    code: "1",
    id: 230,
    name: "ESTADOS UNIDOS",
    short_name: "US"
  }

  public user_ip = undefined;

  constructor(
    public router: Router,
    private http: HttpClient,
    private _appService: AppService,
    private _indexedDBService: IndexedDBService,
  ) {

    this._indexedDBService.openIndexedDB().subscribe(opendb => { });


  }



  getUserIndexedDB = (user_id) => new Observable((observer) => {
    this._indexedDBService.getUser(user_id).subscribe((user: any) => {
      observer.next(user);
    });
  });


  public indexedDB_user_list;
  getUserListIndexedDB = () => new Observable((observer) => {

    this._indexedDBService.getUserList().subscribe((resp: any) => {

      if (resp.status == 'ok' && resp.data.length > 0) {

        this.indexedDB_user_list = JSON.parse(JSON.stringify(resp.data));

        let countries = this.getCountries();

        this.indexedDB_user_list.forEach(user => {
          if (this.validatePhoneNumber(user.username)) {

            let country = countries.filter(country => (country.id == user.country_id));
            user.code = country[0].code;
            user.username = new FormatPhoneNumber().transform(user.username, user.code);

          }
        });

        observer.next(this.indexedDB_user_list);

      } else {
        observer.next(resp.data);
      }
    })
  })

  deleteUserIndexDB = (user_id) => new Observable((observer) => {

    this._indexedDBService.deleteUser(user_id).subscribe((resp: any) => {

      observer.next(resp);

    })
  })

  public user_country_id = undefined;

  getCountry(): Observable<any> {
    return this.http.get(`${UrlPhpApi}/users/getIdCountry`).pipe(
      map((response: any) => {
        if (response?.country_id) {
          this.user_country_id = response.country_id;
        }
        if (response?.ip) {
          this.user_ip = response.ip;
        }
        return response.country_id
      }), retry(3)
    )
  }


  public token;

  isUserAuthenticated() {
    const { isAuthenticated, payload } = this.tokenService.isAuthenticated();
    if (!isAuthenticated) {
      this._appService.setUserData([]);
      return;
    }
    this._appService.setUserData(payload);
    this.tokenService.refreshSession();
  }


  loadUserCountry = () => new Observable((observer) => {

    let countries = this.getCountries()
    this.countries = JSON.parse(JSON.stringify(countries));
    this.countries_copy = JSON.parse(JSON.stringify(countries));

    const setCountry = {
      set: (country_id) => {
        this.country = country_id;
        let country = this.countries.filter(country => (country.id == country_id))
        this.userCountry = country[0];

        observer.next(country_id);
      }
    }

    if (this.user_country_id == undefined) {
      this.getCountry().subscribe(country_id => {
        setCountry.set(country_id);
      })
    } else {
      setCountry.set(this.user_country_id);
    }

  });



  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  validatePhoneNumber(phone) {
    var phoneno = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
    return phone.match(phoneno) ? true : false;
  }


  updateUserIndexedDB = (new_user) => new Observable((observer) => {
    this._indexedDBService.updateUser(new_user).subscribe(resp => {
      observer.next();
    });
  });


  loginLearn(): Observable<any> {

    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.token
    });

    return this.http.get(`${UrlPhpApi}/auths/login.json`, { headers }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        return of(error)
      })
    );
  }


  signOut = (condition?) => new Observable((observer) => {
    this._appService.loadNavBar = this._appService.loadFooter = false;
    this.userLogged = null;

    var redirectItem = sessionStorage.getItem('redirect');
    sessionStorage.clear();
    if (redirectItem != undefined) sessionStorage.setItem('redirect', redirectItem);

    this.logOutLearn(condition).subscribe(resp => {
      this._appService.token = null;
      this.clearAllCookies('SignOut');

      setTimeout(() => {
        observer.next(true);
        if (condition == null) this.router.navigate(['/user/accounts']);
      }, 150);
    });

    this._appService.userSignUpEmail = null;
  });


  logOutLearn(redirect?): Observable<any> {

    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this._appService.token
    });

    return this.http.get(`${UrlPhpApi}/auths/logout`, { headers }).pipe(
      map((response: any) => {
        if (redirect == null) {
          this.router.navigate(['/user/accounts']);

        }
      }),
      catchError(error => {
        if (redirect == null) this.router.navigate(['/user/accounts']);
        return of(error)
      })
    );
  }


  public verifyEmailBefore(attr): Observable<any> {
    return this.http.get(`${UrlLambdaApi}/users/idp/verify?${attr}`, this.getHeadersLambda())
      .pipe(
        map((verify: any) => {
          return verify
        }),
        catchError(this.handleError<any>('verifyEmailBefore', []))
      );

  }


  public getCountries() {

    let countries: any = (countries_data as any).default;

    countries.shift(); //Eliminar el primer (internacional)

    let countries_data_response = [];

    let array_ = [];
    countries.forEach((element, index) => {

      if (index == (countries.length - 1)) {

        countries_data_response = countries.concat(array_);
        countries.sort((a: any, b: any) => {
          let countryA = a.id;
          let countryB = b.id;
          return (countryA < countryB) ? -1 : (countryA > countryB) ? 1 : 0;
        });

      }
    });

    this.countries = countries_data_response;
    return countries_data_response
  }

  getHeadersLambda(): any {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this._appService.token
    })

    return ({ headers: headers });
  }


  public getCertifications(): Observable<any> {

    return this.http.get(`${UrlLambdaApi}/dynamo/certifications?estado=1&user_id=${this._appService.user_data.id}`, this.getHeadersLambda())
      .pipe(
        map((certifications: any) => {

          const { data, status } = certifications;

          let data_return = [];
          if (status) {
            data_return = JSON.parse(JSON.stringify(data));
          }

          return data_return
        }),
        retry(3),
        catchError(this.handleError<any>('getCertifications', []))
      );

  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      console.log('%cerror::', 'color:red', error);

      return of(result as T);
    };
  }


  sendEmailVerificationPHP(email): Observable<any> {
    return this.http.get(`https://edutin.com/emails/send_email_forgetpwd.json?email=${email}`)
      .pipe(map((user: any) => {
        return user
      }),
        catchError(this.handleError<any>('sendEmailVerificationPHP', []))
      );
  }

  updatePasswordPHP(data) {

    return this.http.post(`https://edutin.com/users/reset_app.json`, data, this.getHeadersLambda())
      .pipe(map((response: any) => {
        return response
      }),
        catchError(this.handleError('recents_add'))
      );
  }



  getItem(get_url): Observable<any> {
    return this.http.get(`${UrlLambdaApi}${get_url}`, this.getHeadersLambda())
      .pipe(map((data_response: any) => {
        return data_response
      }),
        catchError(this.handleError<any>('getItem', []))
      );
  }


  getUserEmailCellphone(): Observable<any> {

    const { id } = this._appService.user_data;

    return this.http.get(`${UrlLambdaApi}/users/${id}?fields=["email","cellphone","country_id"]`, this.getHeadersLambda())
      .pipe(map((user: any) => {
        const { data, status } = user;
        let data_return = [];

        if (status) {
          data_return = JSON.parse(JSON.stringify(data));
        }
        return data_return
      }),
        catchError(this.handleError<any>('getUserData', []))
      );
  }



  getUserData(): Observable<any> {

    const { id } = this._appService.user_data;

    return this.http.get(`${UrlLambdaApi}/users/${id}`, this.getHeadersLambda())
      .pipe(map((user: any) => {
        const { data, status } = user;
        let data_return = [];

        if (status) {
          data_return = JSON.parse(JSON.stringify(data));
        }
        return data_return
      }),
        catchError(this.handleError<any>('getUserData', []))
      );
  }

  getFileUrl(tokenhash, qr_type): Observable<any> {
    let type = qr_type == 1 ? 'dni_file' : 'profile_file';

    return this.http.get(`https://api.edutin.com/s/p/file_url?tokenhash="${tokenhash}"&type="${type}"`, this.getHeadersLambda())
      .pipe(map((user: any) => {
        const { data, status } = user;
        let data_return = [];

        if (status) {
          data_return = JSON.parse(JSON.stringify(data));
        }
        return data_return
      }),
        catchError(this.handleError<any>('getFileUrl', []))
      );
  }

  validateDNI(dni): Observable<any> {

    return this.http.get(`https://api.edutin.com/s/p/verification/dni/${dni.dni_number}?file_name=${dni.dni_file}&type=${dni.dni_type}`, this.getHeadersLambda())
      .pipe(map((validation: any) => {
        return validation
      }),
        catchError(this.handleError<any>('getFileUrl', []))
      );
  }


  editItem(url, data): Observable<any> {

    return this.http.put(`${UrlLambdaApi}${url}`, { data }, this.getHeadersLambda())
      .pipe(
        catchError(error => {
          this.handleError('editItem');
          return error;
        })
      );

  }

  addItem(url, data): Observable<any> {

    return this.http.post(`${UrlLambdaApi}${url}`, { data }, this.getHeadersLambda())
      .pipe(
        catchError(this.handleError('addItem'))
      );

  }


  deleteItem(url): Observable<any> {

    return this.http.delete(`${UrlLambdaApi}${url}`, this.getHeadersLambda())
      .pipe(
        catchError(this.handleError('deleteItem'))
      );

  }

  public generateRandomString() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 12; i++)text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }

  putUser(data): Observable<any> {
    const { id } = this._appService.user_data;
    return this.http.put(`${UrlLambdaApi}/users/${id}`, { data }, this.getHeadersLambda())
      .pipe(
        catchError(this.handleError('sourceRecentUpdate'))
      );
  }

  public clearAllCookies(from?) {
    const cookies = document.cookie.split(";");
    cookies.forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      const domain =
        environment.appDomain == "http://127.0.0.1:4200"
          ? "127.0.0.1"
          : ".edutin.com";

      if (from == "onlyRefresh") {
        if (name.includes("refreshToken")) {
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
        }
      } else {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
      }
    });
  }



  cipherPassword(password) {
    return this._indexedDBService.cipher(password);
  }
  decipherPassword(passcipher) {
    return this._indexedDBService.decipher(passcipher);
  }


}
